import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export type ZonedDateTime = { dateTime: string; timeZone: string };

export const nowLocalIso = () => dayjs().format();

export const nowLocalDate = () => dayjs().format('YYYY-MM-DD');

export const nowLocalDateTimeInput = () => dayjs().format('YYYY-MM-DDTHH:mm');

export const toLocalDate = (value: string | Date | Dayjs) => dayjs(value).format('YYYY-MM-DD');

export const toDisplayDate = (value: string | Date | Dayjs) =>
  dayjs(value).format('D MMM YYYY');

export const toUtcZonedDateTime = (local: string | Date | Dayjs): ZonedDateTime => ({
  dateTime: dayjs(local).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
  timeZone: dayjs.tz.guess(),
});
